import { ExtractDataStep } from '@/types/automationSteps.ts';
import { Stack } from '@mantine/core';
import { useUpdateStepFields } from '@/hooks/api/steps/useUpdateStepFields.ts';
import StyledTextarea from '@/components/StyledInputFields/StyledTextarea.tsx';
import { STEP_LOGIC_MAX_LENGTH } from '@/utils/constants.ts';
import { DataInput, InputSource } from '@/types/automationFields.ts';
import useStepSpecificError from '@/hooks/useStepSpecificError.ts';
import { StepErrorType } from '@/types/stepErrorTypes.ts';
import InputSourceSelectField from '@/pages/Editor/components/SharedFields/InputSourceSelectField.tsx';
import * as React from 'react';
import {
  getMultiLogicDataInputs,
  inputSourceAcceptsDataInput,
  inputSourceAcceptsUserSpecified,
} from '@/pages/Editor/components/SharedFields/utils.ts';
import MultiDataInputSelectorUI from '@/pages/Editor/components/SharedFields/DataInputSelector/MultiDataInputSelector/MultiDataInputSelectorUI.tsx';

type props = {
  step: ExtractDataStep;
};

type Fields = {
  instructions_source: InputSource;
  instructions_data_inputs: DataInput[];
  instructions: string;
};

const ExtractMetadataFields = ({ step }: props) => {
  const { fields, onChange, onChangeNoDelay } = useUpdateStepFields<Fields>({ step });

  const invalidLogicDataInput = useStepSpecificError(step, StepErrorType.InvalidLogicDataInput);

  return (
    <Stack w={'100%'}>
      <InputSourceSelectField
        label="Instructions Source"
        value={step.instructions_source}
        onChange={(value) => onChangeNoDelay({ instructions_source: value })}
      />
      {inputSourceAcceptsUserSpecified(fields.instructions_source) && (
        <StyledTextarea
          label={'Instructions'}
          value={fields.instructions}
          placeholder="“The items that i’m extracting are about the location and weather for different cities”"
          onChange={(event) => onChange({ instructions: event.currentTarget.value })}
          maxLength={STEP_LOGIC_MAX_LENGTH}
          autosize
          minRows={3}
        />
      )}
      {inputSourceAcceptsDataInput(fields.instructions_source) && (
        <MultiDataInputSelectorUI
          stepId={step.step_id}
          label={'Instructions Data Inputs'}
          error={invalidLogicDataInput}
          dataInputs={getMultiLogicDataInputs(fields.instructions_data_inputs)}
          updateDataInputs={(dataInputs) =>
            onChangeNoDelay({
              instructions_data_inputs: dataInputs,
            })
          }
        />
      )}
    </Stack>
  );
};

export default ExtractMetadataFields;
